var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2H5C3.34315 2 2 3.34315 2 5V19C2 20.1569 2.65484 21.1608 3.61408 21.6614C3.62784 21.677 3.64217 21.6922 3.65707 21.7071L3.75128 21.7903C3.99562 21.9803 4.30782 22.0412 4.59566 21.973C4.7279 21.9908 4.86288 22 5 22H19C20.6569 22 22 20.6569 22 19V15.005C22 15.0019 22 14.9988 22 14.9957V5C22 3.34315 20.6569 2 19 2ZM20 12.776V5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.2634 4.10185 19.503 4.26832 19.6817L14.6571 9.29289C15.0024 8.94754 15.5409 8.90568 15.9331 9.17747L16.0278 9.25196L20 12.776ZM6.77833 20H19C19.5523 20 20 19.5523 20 19V15.4496L15.405 11.373L6.77833 20ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6ZM9 8C9.55228 8 10 8.44772 10 9C10 9.55228 9.55228 10 9 10C8.44772 10 8 9.55228 8 9C8 8.44772 8.44772 8 9 8Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlock);
export default __webpack_public_path__ + "static/media/icon-block.c9a26dee2abfbcc3b21ded29055295df.svg";
export { ForwardRef as ReactComponent };